export default __webpack_public_path__ + "static/media/delete.e3668688.svg";